import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CommonDependencyService {
  public serviceurl: string = environment.gsfCalculationURL;

  constructor(private readonly http: HttpClient) {}
  getCounty(state, language) {
    const lang = sessionStorage.getItem("language");
    const URL = `${this.serviceurl}gsf/api/soil-calc/county`;
    const body = { lang, state };
    return this.http.post(URL, body);
  }

  public getDependValues(pillarName, question, inputs, getInput, language) {
    const lang = sessionStorage.getItem("language");
    const URL = `${this.serviceurl}gsf/api/calculate/depend-values`;
    const body = { pillarName, question, inputs, getInput, lang };
    return this.http.post(URL, body);
  }
}
